import { Provider } from '@angular/core';
import { provideState } from '@ngrx/store';

import * as fromAuth from './auth';

export function provideAuthState(): Provider {
  return [provideState(fromAuth.featureKey, fromAuth.reducer)];
}
